<div>
  <div class="" v-for="(partner,index) in contractModel.partners" :key="index">
    <div id="accordion">
      <div class="card najiz-card-panel mb-3">
        <div class="card-header najiz-panel-header" id="headingOne">
          <h4 class="mb-0 py-3">
            <b>
              <span v-if="partner.partnerTarafTypeId == 1"> بيانات الطرف الأول</span>
              <span v-if="partner.partnerTarafTypeId == 2"> بيانات الطرف الثاني</span>
              <span v-if="partner.partnerTarafTypeId == 3"> بيانات المحامي</span>
            </b>
          </h4>
        </div>
        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <h4 class="py-3">
                <b>
                  {{partner.firstName}} {{partner.fatherName}} {{partner.grandFatherName}}
                  {{partner.familyName}}
                </b>
              </h4>
            </div>
            <div class="form-row justify-content-start" v-if="partner">

              <div class="col-lg-2 col-md-2 col-sm-12" v-if="partner.socialId">
                <label for="disabledTextInput">نوع الهوية</label>
                <p> <b> {{partner.socialId | getSocialIdType}}</b></p>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12">
                <label for="disabledTextInput">رقم الهوية</label>
                <p class="mb-0"> <b> {{partner.socialId}} </b></p>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12">
                <label for="disabledTextInput">الجنسية</label>
                <p class="mb-0"> <b>{{partner.nationalityName}}</b></p>
              </div>

              <div class="col-lg-1 col-md-1 col-sm-12">
                <label for="disabledTextInput">النوع</label>
                <p class="mb-0">
                  <b v-if="partner.gender==1"> ذكر </b>
                  <b v-if="partner.gender==2"> أنثى </b>
                </p>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12" v-if="partner.birthDate">
                <label for="disabledTextInput">تاريخ الميلاد</label>
                <p class="mb-0"> <b> {{partner.birthDate | formatGregToHijri}} هـ -
                    {{partner.birthDate|getFormattedDate}}م </b></p>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12">
                <label>رقم الجوال </label>

                <p class="mb-0"><b> {{partner.mobileNumber}} </b></p>

              </div>
              <div class="col-lg-2 col-md-2 col-sm-12" v-if="partner.partnerTarafTypeId==tarafTypeEnum.Lawyer">
                <label>رقم رخصة المحاماة </label>

                <p class="mb-0"><b> {{partner.licenseNumber}} </b></p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="accordion">
    <div class="card najiz-card-panel mb-3">
      <div class="card-header najiz-panel-header" id="headingOne">
        <h4 class="mb-0 py-3">
          <b>
            مدة العقد
          </b>
        </h4>
      </div>
      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
        <div class="card-body" v-if="contractModel">
          <div class="d-flex" v-if="contractModel && contractModel.startDate && contractModel.endDate">
            <div>
              <label for="disabledTextInput">تاريخ بداية العقد</label>
              <p class="mb-0"> <b> {{contractModel.startDate.gregDate | formatGregToHijri}} هـ </b></p>
            </div>
            <div class="mx-15">
              <label for="disabledTextInput">تاريخ نهاية العقد</label>
              <p class="mb-0"> <b> {{contractModel.endDate.gregDate | formatGregToHijri}} هـ </b></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="accordion">
    <div class="card najiz-card-panel mb-3">

      <div class="card-header najiz-panel-header" id="headingOne">
        <h4 class="mb-0 py-3">
          <b>
            مراجعة العقد
          </b>
        </h4>
      </div>
      <div id="collapseOne" class="collapse show  height-scroll" aria-labelledby="headingOne" data-parent="#accordion">
        <div class="card-body">


          <h5 class="text-center "> <u>{{contractModel.contractName}}</u></h5>

          <h5 v-if="contractModel.firstPartner"><u> الطرف الأول</u>:</h5>
          <p v-if="contractModel.firstPartner">{{contractModel.firstPartner.firstName}}
            {{contractModel.firstPartner.fatherName}} {{contractModel.firstPartner.grandFatherName}}
            {{contractModel.firstPartner.familyName}}</p>
          <h5 v-if="contractModel.secondPartner"><u> الطرف الثاني</u>:</h5>
          <p v-if="contractModel.secondPartner">{{contractModel.secondPartner.firstName}}
            {{contractModel.secondPartner.fatherName}} {{contractModel.secondPartner.grandFatherName}}
            {{contractModel.secondPartner.familyName}}</p>

          <h5 v-if="contractModel.introductionLabel!='<p><br></p>'"><u> المقدمة</u>:</h5>
          <p v-if="contractModel.introductionLabel!='<p><br></p>'" id="introduction"
            v-html="contractModel.introductionLabel"></p>
          <h5 v-if="contractModel.preliminaryLabel!='<p><br></p>'"><u> تمهيد</u>:</h5>
          <p v-if="contractModel.preliminaryLabel!='<p><br></p>'" id="preliminary"
            v-html="contractModel.preliminaryLabel"></p>

          <div v-for="(clause,masterIndex) in clausesText">
            <div class="mb-5 h-100">
              <div class="pb-0">

                <p><u><b> {{masterIndex | getIndexedClauseName}} : {{clause.clauseName}}</b></u></p>
                <ul>
                  <li v-for="(textItem,index) in clause.childClauses" :key="textItem.id">
                    <div class="w-100 ">
                      <p dir="rtl">
                        {{index+1 + ' - ' }}
                        <span :id="'clause_'+textItem.id" v-html="textItem.labelText"></span>
                      </p>
                      <ul class="pr-7 pt-1">
                        <li v-for="(subTextItem,subIndex) in  textItem.childClauses" :key="subTextItem.id">
                          <p>
                            {{subIndex | getIndexedLetter }} -
                            <span :id="'clause_'+textItem.id+'_'+subTextItem.id" v-html="subTextItem.labelText"></span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row pt-5">
    <div class="col-12">
      <hr class="footer-hr pt-0 mt-0" />
      <div class="d-flex ">
        <button type="button" class="btn btn-link text-danger ml-auto pr-0 text-decoration-none"
          @click="onCancel">إلغاء</button>
        <a class="btn btn-outline-primary mx-4 px-8" @click="previousStep">السابق</a>
        <a class="btn btn-primary px-8" @click="onSubmitContract">إرسال الطلب</a>
      </div>
    </div>
  </div>
  <OtpComponent ref="otp" :nationalId="currentUser.username" @verify="submitContract" />
</div>